export default "__VITE_ASSET__BEp9y8oP__"